import React from 'react';

const TotalsRow = (props) => {
	const grandTotal = (props.lowincome === 'true') ? props.result.grandTotalLow : props.result.grandTotal;

	return (
		<div className={`${props.classes} app__totals`}>
			<div className="app__responsive-wrap app__emco_col_6">
				<div className="app__results-savings">
					<p>{props.content.totalTitle}</p>
					<p className="app__results-dollars">
						<span className="app__results_range-title--super">{props.content.provincialSuper}</span>
						<span className="app__results_range-title">{grandTotal}</span>
					</p>
				</div>
			</div>
			<div className="app__responsive-wrap app__emco_col_6">
				<div className="app__results-thankyou">
					<p>{props.content.totalCopy}</p>
				</div>
				<div className={'app__results-button  app__results-button--display'}>
					<button className="app__button-reset app__results-restart" onClick={props.reset}>{props.content.startOver}
						<span>&#8634;</span>
					</button>
				</div>
			</div>
		</div>
	);
};

export default TotalsRow;



// WEBPACK FOOTER //
// ./src/components/TotalsRow.js